module.exports = "<nv-react-component component=\"LearningCatalogModalContent\"></nv-react-component>";